import type { TThemes } from '../models';

export const getAddonTheme = (theme: TThemes, disabled: boolean) => {
    if (disabled) {
        return theme === 'blue' ? 'disabledInverted' : 'disabled';
    }

    return theme === 'blue' ? 'primaryInverted' : 'primary';
};

export const getCaptionTheme = (
    error: boolean,
    errorText: string,
    theme: TThemes,
    disabled: boolean
) => {
    if ((error || errorText) && !disabled) {
        return 'accent';
    }

    return theme === 'blue' ? 'secondaryInverted' : 'secondary';
};
